import * as types from '../actions/types';
import initialState from './initialState';
import { default as config } from '../constants';


export default function lineItemReducer(state = initialState.lineItems, action) {
	// For these specific actions i want to manipulate state in this
	// way...
	let result = {};
	switch (action.type) {
		case types.LOAD_BUDGET_LINE_ITEM_SUCCESS: 
			result = Object.assign({}, state);
			result["li" + action.item.id] = action.item.acf;
			return result;
		case types.LOAD_BUDGET_LINE_ITEM_FAILURE:
			return state;
		case types.PENDING_BUDGET_LINE_ITEM: 
			result = Object.assign({}, state);
			result["li" + action.item.id] = action.item;
			return result;
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/lineItemReducer.js